module.exports = __webpack_public_path__ + "images/Logo-gilen-5abcc91ab744e92d872d6723453d004a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos_icons/Logo-gilen.png
// module id = 784
// module chunks = 0